import React from 'react';
import { useParams } from 'react-router-dom';
import { SCOPE_OFFER } from '../../_CONST';
import GlobalVariableForm from './components/globalVariable/GlobalVariableForm';

const CreateGlobalVariableDocument = () => {
  const { offerId } = useParams();
  return (
    <GlobalVariableForm
      scope={SCOPE_OFFER}
      offerId={offerId}
    />
  );
};

export default CreateGlobalVariableDocument;
